// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".layout-declarations[data-v-5c8a5fd0]{height:100%}.layout-declarations__aside--left[data-v-5c8a5fd0],.layout-declarations__main[data-v-5c8a5fd0]{height:100%;overflow-y:auto}.layout-declarations__main[data-v-5c8a5fd0]{flex:1}.layout-declarations__fab[data-v-5c8a5fd0]{margin-bottom:40px}.layout-declarations__main[data-v-5c8a5fd0]{background-color:#fff}", ""]);
// Exports
module.exports = exports;
